import React, { Component } from 'react'
import { connect } from 'react-redux'
import FontAwesome from 'react-fontawesome'
import moment from 'moment'

import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import BoxButton from '../Layout/BoxButton'
import SelectorInput from '../../components/Shared/SelectorInput'
import Box from '../Layout/Box'

import numeral from 'numeral'

import ModalCreateOtrosi from '../Otrosi/ModalCreate'

import {
	showHideModalAddAdicional,
    updateInputs,
    addCencoItem,
    removeCencosItem,
	storeAdicion,
} from '../../actions/documentos'


import {
	createOtrosi
} from '../../actions/otrosi'


import { showModalSelector, selectFromSelector } from '../../actions/common'

class ModalAddAdicional extends Component {
	handleCloseModal = (e) => {
		const modal = document.getElementById('modalAddAdicional')
		modal.classList.remove('fadeIn')
		modal.classList.add('fadeOut')

		const modalDialog = document.querySelector(`#modalAddAdicional .modal-dialog`)
		modalDialog.classList.remove('zoomIn')
		modalDialog.classList.add('zoomOut')

		setTimeout(() => this.props.showHideModalAddAdicional(false), 300)
	}

    handleOpenSelector = (list) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }   
		]
		const responsables = [];
        const payload = {}
        const fn = (a) => {
			const index = this.props.modalAddAdicional.getIn(['data', 'cencos']).findIndex(c => c.getIn(['cenco', 'id']) == a.id)
			if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
				payload.path = list
				payload.value = a
				this.props.selectFromSelector('MODIFICAR_INPUTS_DOCUMENTOS', payload)
			}
		}

		this.props.modalAddAdicional.get('detalles').valueSeq().forEach(detalle => {
			detalle.get('cencos').valueSeq().forEach(cenco => responsables.push(cenco.get('responsable_id')))
		})

		const customFilter = { column: 'T0.responsable_id', operator: 'IN', value: `(${responsables.join(',')})`, comparison: 'number' }
		this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
		
	}

	render() {
		const { modalAddAdicional, tipo_solicitud } = this.props
		if (!modalAddAdicional.get('show')) {
			return null
		}



		const boxActions = [
            <BoxButton key="ba[0][0]" size={14} name="plus-circle" onClick={ e => this.props.addCencoItem() } title="Nueva" />,
            <BoxButton key="ba[0][1]" size={14} name="trash" onClick={ e => this.props.removeCencosItem() } title="Eliminar" disabled={ modalAddAdicional.getIn(['data', 'cencos']).filter(x => x.get('selected')).count() === 0 } danger/>,
		]


		return(
			<Modal id="modalAddAdicional" show={ true } ZIndex={ 2000 } >
				<ModalHeader title="Creación de adicionales" onClose={ (e) => this.handleCloseModal(e) } />
                <ModalButtonStrip>

                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
						onClick={ e => this.props.storeAdicion() }
						disabled={ modalAddAdicional.get('guardando') }
                    />


                    {/* <BoxButton
                        name="floppy-o"
                        title="Solicitar OTROSI"
                        onClick={ e => this.props.createOtrosi() }
                    /> */}



                </ModalButtonStrip>
				<ModalBody>
					<div style={{ width: '60vw', height: '40vh', overflowX: 'hidden' }}>
                        <div className="row">
                            <div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Descripción</label>
                                    <textarea className="form-control input-sm" rows={4} value={ modalAddAdicional.getIn(['data', 'descripcion']) } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.descripcion`, e.target.value) } />
								</div>
                            </div>
                        </div>						
                        <div className="row">

                            <div className={tipo_solicitud !== 3 ? "col-md-2" : "col-md-3"}>
								<div className="form-group">
									<label className="control-label">Cantidad</label>
                                    <input type="number" className="form-control input-sm" value={ modalAddAdicional.getIn(['data', 'cantidad']) || '' } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.cantidad`, e.target.value) } disabled={tipo_solicitud==3}/>
								</div>
                            </div>


							<div className={tipo_solicitud !== 3 ? "col-md-2" : "col-md-3"}>
								<div className="form-group">
									<label className="control-label">Valor total sin IVA</label>
                                    <input type="number" className="form-control input-sm" value={ modalAddAdicional.getIn(['data', 'valor']) } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.valor`, e.target.value, tipo_solicitud) } />
								</div>
                            </div>


                            { tipo_solicitud !== 3 && <div className="col-md-2">
								<div className="form-group">
									<label className="control-label">IVA, %</label>
                                    <input type="number" className="form-control input-sm" value={ modalAddAdicional.getIn(['data', 'iva']) } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.iva`, e.target.value, tipo_solicitud) } />
								</div>
							</div> }

							{

								(tipo_solicitud !== 3) ? (
									<div className={"col-md-3"}>
										<div className="form-group">
											<label className="control-label">Valor total</label>
											<input className="form-control input-sm" value={ numeral(modalAddAdicional.getIn(['data', 'cantidad']) * modalAddAdicional.getIn(['data', 'valor_con_iva'])).format('$0,0.00') } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.valor_con_iva`, e.target.value, tipo_solicitud) } disabled />
										</div>
									</div>
								):(
									<div className={ "col-md-3" }>
										<div className="form-group">
											<label className="control-label">Valor total</label>
											<input className="form-control input-sm" value={ modalAddAdicional.getIn(['data', 'valor_con_iva']) } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.valor_con_iva`, e.target.value, tipo_solicitud) } />
										</div>
									</div>
								)
							}


                            <div className="col-md-3">
								<div className="form-group">
									<label className="control-label">Fecha de entrega</label>
                                    <input type="date" className="form-control input-sm" value={ moment(modalAddAdicional.getIn(['data', 'fecha_entrega'])).format('YYYY-MM-DD') || '' } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.fecha_entrega`, e.target.value) } />
								</div>
                            </div>

                        </div>
                        <div className="separator" />
						<div className="row">
							<div className="col-md-12">
								<Box title="Centros de costo" actions={ boxActions } onModal>
									<div className="box-content" style={{ height: '81px', overflowX: 'hidden' }}>
										<table className="table table-condensed">
											<tbody>
												{
													modalAddAdicional.getIn(['data', 'cencos']).map((x, n) => {
														return (
															<tr key={ `tr[${x.get('guid')}]` }  className={ x.get('selected') ? 'info-dark' : '' } >
																<td style={{ width: '20px' }} ><input type="checkbox" style={{ marginTop: '6px' }} checked={ x.getIn('selected') } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.cencos.${n}.selected`, e.target.checked) } /></td>
																<td style={{ width: '20px', verticalAlign: 'middle' }} ><span>{ n + 1 }</span></td>
																<td style={{ width: '75%' }} >
                                                                    <SelectorInput value={ x.getIn(['cenco', 'descripcion']) ? x.getIn(['cenco', 'descripcion']) : '' } onClick={ () => this.handleOpenSelector(`modalAddAdicional.data.cencos.${n}.cenco`) } onReset={ () => this.props.updateInputs(`modalAddAdicional.data.cencos.${n}.cenco`, null) } />																				
                                                                </td>
																<td><input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.get('porcentaje') } onChange={ (e) => this.props.updateInputs(`modalAddAdicional.data.cencos.${n}.porcentaje`, e.target.value) } /></td>
																<td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
															</tr>
														)
													})
												}
											</tbody>
										</table>
									</div>
								</Box>
							</div>
						</div>


					</div>
				</ModalBody>
				<ModalFooter>
				</ModalFooter>				

				<ModalCreateOtrosi />

			</Modal>
		)
	}
}

const mapStateToProps = (state, onwProps) => {
	return {
		modalAddAdicional: state.documentos.get('modalAddAdicional'),
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		showHideModalAddAdicional: (open) => dispatch(showHideModalAddAdicional(open)),
        updateInputs: (path, value, tipo_solicitud) => dispatch(updateInputs(path, value, null, true, tipo_solicitud)),
        addCencoItem: () => dispatch(addCencoItem()),
        removeCencosItem: () => dispatch(removeCencosItem()),
		showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
		selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
		storeAdicion: () => dispatch(storeAdicion()),
		createOtrosi: () => dispatch(createOtrosi()),
		
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddAdicional)



// WEBPACK FOOTER //
// ./src/components/Documentos/ModalAddAdicional.jsx